"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.EXPORT_ONLY_ID_PREFIX = void 0;
var EXPORT_ONLY_ID_PREFIX = exports.EXPORT_ONLY_ID_PREFIX = "export-only";
var ExportOnlyColumn = function ExportOnlyColumn(_) {
  return null;
};
ExportOnlyColumn.toColumnDef = function (child) {
  var props = child.props;
  var header = props.header,
    value = props.value;
  return {
    id: "".concat(EXPORT_ONLY_ID_PREFIX, "-").concat(header),
    meta: {
      header: header,
      visible: false
    },
    header: header,
    accessorFn: function accessorFn(originalRow) {
      return typeof value === "function" ? value(originalRow) : value;
    }
  };
};
var _default = exports.default = ExportOnlyColumn;